import {
  string as yupString,
  number as yupNumber,
} from 'yup';

import InputFormik from '../../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../../shared/forms/select/sdkSelectFormik.component';
import { required, maxLength, uniqueWith, integer } from '../../../shared/forms/validators';

const schema = [
  {
    name: 'connName',
    component: InputFormik,
    meta: { label: 'Connection Name' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required, maxLength(50), uniqueWith([], 'Connection Name already exists')] },
    additionalProps: { required: true },
  },
  {
    name: 'connType',
    component: SelectFormik,
    meta: { label: 'Type', optionsKey: 'connectionTypeOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'enabledFlag',
    component: SelectFormik,
    meta: { label: 'Enabled Flag', optionsKey: 'enabledFlagOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'inboundName',
    component: InputFormik,
    meta: { label: 'Inbound Name' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
  {
    name: 'outboundName',
    component: InputFormik,
    meta: { label: 'Outbound Name' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
  {
    name: 'inboundFolderName',
    component: InputFormik,
    meta: { label: 'Inbound Folder Name' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
  {
    name: 'outboundFolderName',
    component: InputFormik,
    meta: { label: 'Outbound Folder Name' },
    options: { yupType: yupString(), validationRules: [maxLength(50)] },
  },
  {
    name: 'generateJeFlag',
    component: SelectFormik,
    meta: { label: 'Generate JE Flag', optionsKey: 'generateJeFlagOptions' },
    options: { yupType: yupString() },
    additionalProps: { clearable: true },
  },
  {
    name: 'bsmJeFlag',
    component: SelectFormik,
    meta: { label: 'BSM JE Flag', optionsKey: 'bsmJeFlagOptions' },
    options: { yupType: yupString() },
    additionalProps: { clearable: true },
  },
  {
    name: 'sourceFolder',
    component: InputFormik,
    meta: { label: 'Source Folder' },
    options: { yupType: yupString(), validationRules: [maxLength(256)] },
  },
  {
    name: 'deleteRawTbData',
    component: SelectFormik,
    meta: { label: 'Delete RAW TB Data', optionsKey: 'deleteRawTbDataOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'notificationEmail',
    component: InputFormik,
    meta: { label: 'Notification Email' },
    options: { yupType: yupString() },
  },
  {
    name: 'lcdMcCloseStart',
    component: InputFormik,
    meta: { label: 'LCD MC Close Start (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'lcdMcCloseEnd',
    component: InputFormik,
    meta: { label: 'LCD MC Close End (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'lcdQcCloseStart',
    component: InputFormik,
    meta: { label: 'LCD QC Close Start (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'lcdQcCloseEnd',
    component: InputFormik,
    meta: { label: 'LCD QC Close End (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'lcdYeCloseStart',
    component: InputFormik,
    meta: { label: 'LCD YE Close Start (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'lcdYeCloseEnd',
    component: InputFormik,
    meta: { label: 'LCD YE Close End (days)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'scheduleType',
    component: InputFormik,
    meta: { label: 'Schedule Type' },
    options: { yupType: yupString(), validationRules: [maxLength(1)] },
  },
  {
    name: 'runInterval',
    component: InputFormik,
    meta: { label: 'Run Interval (minutes)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'jobInterval',
    component: InputFormik,
    meta: { label: 'Job Interval (minutes)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
  {
    name: 'runSla',
    component: InputFormik,
    meta: { label: 'Run SLA (minutes)' },
    options: { yupType: yupNumber(), validationRules: [integer] },
    additionalProps: { type: 'number', step: '1' },
  },
];

export default schema;
